@if (linkAccount$ | async) {}
<div class="flex flex-column justify-content-center align-items-center gap-8">
  <div class="flex flex-column justify-content-center align-items-center gap-6">
    <div class="flex justify-content-center align-items-center gap-5">
      <img
        class="w-5rem h-5rem"
        src="https://gapp-media.s3.ap-southeast-1.amazonaws.com/public/icons/web/icon-main-logo.svg"
        alt="main-logo"
      />
      <i class="pi pi-link text-green-500 text-4xl"></i>
      <img class="border-circle object-contain w-5rem h-5rem" [src]="imgConnectingSignal()" alt="line-green" />
    </div>
    <div class="flex flex-column justify-content-center align-items-center gap-5">
      <p class="text-2xl text-gray font-semibold">เชื่อมต่อ AIFLOW CRM กับ {{ socialProvider }}</p>
      <p *appHiddenProd class="text-base text-bluegray-500 font-normnal break-word">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vulputate sed sem ac tempus. Phasellus in tincidunt urna, id faucibus
        ligula. Phasellus nunc ipsum, ullamcorper cursus tempor quis, suscipit vitae ante.
      </p>
    </div>
  </div>
  <div class="w-full">
    <p-button [label]="'Sync with ' + socialProvider" severity="success" styleClass="w-full px-0" (onClick)="linkAccount()">
      <ng-template pTemplate="icon">
        <div class="border-right-1" style="border-color: #00000025">
          <p-image src="assets/icons/icon-line.png" alt="line" imageClass="flex px-2" [imageStyle]="{ width: '40px', height: '22px' }" />
        </div>
      </ng-template>
    </p-button>
  </div>
</div>
